import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./WorkingMemoryGame.css";

const WorkingMemoryGame = () => {

  const navigate = useNavigate();
   useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  const [level, setLevel] = useState(1);
  const [sequence, setSequence] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayNumber, setDisplayNumber] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [userInput, setUserInput] = useState("");

  const [startTime, setStartTime] = useState(null);
  const [time, setTime] = useState(0);

  const [page, setPage] = useState("game");

  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);
  const [allResults, setAllResults] = useState([]);

  // ✅ track completed level separately (IMPORTANT)
  const [completedLevel, setCompletedLevel] = useState(0);

  // ================= GENERATE =================
  const generateSequence = (len) => {
    return Array.from({ length: len }, () =>
      Math.floor(Math.random() * 9) + 1
    );
  };

  // ================= START =================
  const startTest = () => {
    const seq = generateSequence(level + 2);
    setSequence(seq);
    setCurrentIndex(0);
    setDisplayNumber("");
    setShowInput(false);
  };

  useEffect(() => {
    startTest();
  }, [level]);

  // ================= SHOW NUMBERS =================
  useEffect(() => {

    if (currentIndex < sequence.length && sequence.length > 0) {

      const show = setTimeout(() => {
        setDisplayNumber(sequence[currentIndex]);
      }, 500);

      const hide = setTimeout(() => {
        setDisplayNumber("");
        setCurrentIndex((prev) => prev + 1);
      }, 1500);

      return () => {
        clearTimeout(show);
        clearTimeout(hide);
      };
    }

    if (currentIndex === sequence.length && sequence.length > 0) {
      setShowInput(true);
      setStartTime(performance.now());
    }

  }, [currentIndex, sequence]);

  // ================= VALIDATE =================
 const handleSubmit = () => {

  const end = performance.now();
  const taken = ((end - startTime) / 1000).toFixed(2);
  setTime(taken);

  const correct = sequence.join("") === userInput;

  // 🔥 CREATE UPDATED ARRAY (IMPORTANT)
  const updatedResults = [
    ...allResults,
    {
      level: level,
      userInput: userInput,
      correctSequence: sequence.join("")
    }
  ];

  // 🔥 UPDATE STATE
  setAllResults(updatedResults);

  if (correct) {
    setUserInput("");
    setLevel((prev) => prev + 1);
  } else {

    const finalLevel = Math.max(0, level - 1);
    setCompletedLevel(finalLevel);

    // 🔥 PASS UPDATED DATA
    finishGame(finalLevel, updatedResults);
  }
};
  // ================= LEADERBOARD =================
  const fetchLeaderboard = async () => {
    try {

      const email = localStorage.getItem("rg_email");

      const res = await axios.get(`/workingmemoryleaderboard?email=${email}`);

      setLeaderboard(res.data.leaderboard || []);
      setUserRank(res.data.userRank);

    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  // ================= FINISH =================
  const finishGame = async (finalLevel, resultsData) => {

  setPage("result");

  const email = localStorage.getItem("rg_email");

  try {

    await axios.post("/save-working-memory", {
      email,
      sessions: resultsData
    });

    await fetchLeaderboard();

  } catch (e) {
    console.log(e);
  }

};
  // ================= UI =================
  return (
    <div className="wm-game-container">

      {page === "game" && (
        <>
          <h2 className="wm-level">Level {level}</h2>

          {!showInput && (
            <div className="wm-number">
              {displayNumber}
            </div>
          )}

          {showInput && (
            <div className="wm-input-box">

              <p>Enter sequence</p>

              <input
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSubmit(); // 🔥 UX boost
                }}
              />

              <button onClick={handleSubmit}>
                Submit
              </button>

            </div>
          )}
        </>
      )}

      {/* ================= RESULT ================= */}
      {page === "result" && (

        <div className="result-big-container">

          {/* LEADERBOARD */}
          <div className="leaderboard-box">

            <h3>Leaderboard</h3>

            <table>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Level</th>
                  <th>Medal</th>
                </tr>
              </thead>

              <tbody>
                {leaderboard.slice(0,5).map((p, i) => {

                  let medal = "";
                  if (i === 0) medal = "🥇";
                  else if (i === 1) medal = "🥈";
                  else if (i === 2) medal = "🥉";

                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{p.name}</td>
                      <td>{p.level}</td>
                      <td>{medal}</td>
                    </tr>
                  );
                })}
              </tbody>

            </table>

            {userRank && (
              <div className="your-rank-box">
                Rank: {userRank.rank} <br/>
                Level: {Math.max(0, level - 1)}<br/>
                Percentile: {userRank.percentile}%
              </div>
            )}

          </div>

          {/* RESULT */}
          <div className="results-box">

            <h2>Your Result</h2>

            <p>Level Reached: {level - 1}</p> {/* 🔥 FIXED */}
            <p>Time: {time}s</p>

            <button onClick={() => window.location.reload()}>
              Try Again
            </button>

            <button onClick={() => navigate("/working-memory")}>
              Exit
            </button>

          </div>

        </div>

      )}

    </div>
  );
};

export default WorkingMemoryGame;